import React from "react";
import { Button } from "reactstrap";
import { Download } from "lucide-react";
import { api } from "../util/api";
import { JobStatusTracker } from "../components/JobStatusTracker";

export const ExportButton = ({ payorIds, procedureCodes, disabled, onError }) => {
  const startExport = async () => {
    const { data } = await api.post("/coverages/export", { payor_ids: payorIds, procedure_codes: procedureCodes });
    return data.job_id;
  };

  const handleFinished = ({ payload }) => {
    if (payload?.download_path) {
      window.location.assign(payload.download_path);
    }
  };

  return (
    <JobStatusTracker
      start={startExport}
      label="Exporting"
      onFinished={handleFinished}
      onFailed={({ error }) => onError(error || "The export failed. Please try again.")}
    >
      {(start, { starting }) => (
        <Button color="secondary" outline size="sm" onClick={start} disabled={disabled || starting}>
          <Download size={16} className="me-1" />
          Export CSV
        </Button>
      )}
    </JobStatusTracker>
  );
};
